import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=77e1f1f5&scoped=true&lang=html&"
import script from "./Groups.vue?vue&type=script&lang=js&"
export * from "./Groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e1f1f5",
  null
  
)

export default component.exports